<template>
  <BaseModal
    v-model="model"
    title="Creación de nuevo cobro"
    size="lg"
    :loading="loading"
    :scrollable="false"
    @confirm-button-click="handleConfirmButtonClick"
  >
    <validation-observer ref="sale-invoice-collect-creation-form">
      <b-form
        class="py-2"
        @submit.prevent
      >
        <b-row align-h="center">
          <b-col
            sm="12"
            lg="10"
          >
            <validation-provider
              v-slot="validationContext"
              name="Fecha"
              rules="required"
            >
              <b-form-group
                label="Fecha"
                label-for="sale-invoice-collect-date"
              >
                <b-form-datepicker
                  id="sale-invoice-collect-date"
                  v-model="form.collect_date"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  :state="$getValidationState(validationContext)"
                  placeholder="Fecha"
                  size="sm"
                  reset-button
                  :hide-header="true"
                  :label-help="null"
                  start-weekday="1"
                />
                <small class="text-danger">{{ validationContext.errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col
            sm="12"
            lg="10"
          >
            <validation-provider
              v-slot="validationContext"
              name="Importe"
              :rules="'required|max_value:' + maxAmount"
            >
              <b-form-group
                label="Importe"
                label-for="sale-invoice-collect-amount"
              >
                <b-input-group class="input-group-merge">
                  <b-form-input
                    id="sale-invoice-collect-amount"
                    v-model="form.amount"
                    placeholder="Importe"
                    type="number"
                    :state="$getValidationState(validationContext)"
                  />
                  <b-input-group-append is-text>
                    €
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ validationContext.errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </BaseModal>
</template>

<script>
import { mapActions } from 'vuex'
import SaleInvoiceCollectsApi from '@/api/sale-invoice-collects-api'
import DateTimeService from '@/shared/services/date-time-service'
import BaseModal from '@/components/ui/modal/BaseModal.vue'

export default {
  name: 'SaleInvoiceCollectCreationModal',
  components: { BaseModal },
  props: {
    value: {
      default: false,
      type: Boolean,
    },
    saleInvoice: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      maxAmount: null,
      form: {
        amount: null,
        collect_date: DateTimeService.today(),
      },
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {
    model(value) {
      if (value) {
        this.loadRemainingPayment()
      }
    },
  },
  methods: {
    ...mapActions('saleInvoice', ['loadSaleInvoice']),
    async loadRemainingPayment() {
      if (this.form.amount || !this.saleInvoice) {
        return
      }

      this.loading = true
      try {
        const remaining = await SaleInvoiceCollectsApi.getRemaining(this.saleInvoice.id)
        this.form.amount = remaining
        this.maxAmount = remaining
      } finally {
        this.loading = false
      }
    },
    async handleConfirmButtonClick() {
      const valid = await this.$refs['sale-invoice-collect-creation-form'].validate()
      if (!valid || !this.saleInvoice) {
        return
      }

      this.loading = true
      try {
        await SaleInvoiceCollectsApi.create({ ...this.form, sale_invoice_id: this.saleInvoice.id })
        await this.loadSaleInvoice({ saleInvoiceId: this.saleInvoice.id });
        this.$emit('input', false)
        this.clearForm()
      } finally {
        this.loading = false
      }
    },
    clearForm() {
      this.form = { amount: null, payment_date: null }
    },
  },
}
</script>

<style scoped>
</style>
